import { Component } from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';
import i18n from '../../i18n';
import { formatError, hasError } from '../../utils/formatError';
import DialogSelectField from '../editors/DialogSelectField';

class AssignDialog extends Component {
    onClose = () => {};
    onSave = () => {};
    itemIdKey = '';
    assignedIdKey = '';
    assignedKey = '';
    title = '';
    controller = '';
    constructor(props) {
        super(props);
        this.state = {
            open: props.open || false,
            alertText: '',
            itemId: props.itemId || '',
            assignedId: props.assignedId || '',
            assignableList: props.assignableList || []
        };
        this.onClose = props.onClose;
        this.onSave = props.onSave;
        this.itemIdKey = props.itemIdKey;
        this.assignedIdKey = props.assignedIdKey;
        this.title = props.title;
        this.controller = props.controller;
        this.assignedKey = props.assignedKey;
    }
    static getDerivedStateFromProps(props, state) {
        if (props.open !== state.open) {
            return {
                open: props.open,
                itemId: props.itemId,
                assignedId: props.assignedId,
                assignableList: props.assignableList
            };
        }
        return null;
    }
    handleAssign(event) {
        const server = this.props.server;
        this.setState({ loading: true });
        server
            .assign({
                [this.itemIdKey]: this.state.itemId,
                [this.assignedIdKey]: this.state.assignedId
            })
            .then((result) => {
                if (!hasError(result)) {
                    this.setState({ loading: false });
                    this.onSave();
                } else {
                    this.setState({ loading: false });
                    this.setState({ alertText: formatError(result) });
                }
            });
    }
    render() {
        const { alertText, open, assignedId, assignableList } = this.state;
        return (
            <Dialog open={open} onClose={this.onClose}>
                <DialogTitle>{i18n.t(`dialogs.${this.title}`)}</DialogTitle>
                {alertText && <Alert severity="error">{alertText}</Alert>}
                <DialogContent>
                    {/* Todo: Add select field with  assignableList items*/}
                    <DialogSelectField
                        value={assignedId}
                        onChange={(event) =>
                            this.setState({ assignedId: event.target.value })
                        }
                        options={assignableList}
                        field={{
                            id: this.assignedIdKey,
                            label: this.assignedIdKey,
                            alignRight: false,
                            // searchFields: ['name'],
                            // outputField: 'id',
                            // searchController: this.controller,
                            object: this.assignedKey,
                            from: this.controller,
                            show: 'name'
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onClose}>
                        {i18n.t('buttons.cancel')}
                    </Button>
                    <Button onClick={(event) => this.handleAssign(event)}>
                        {i18n.t('buttons.save')}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}
export default AssignDialog;
